import React, { useEffect, useState, useMemo } from "react"
import { Container, Row, Col } from "reactstrap"

//import Components
import { useSelector, useDispatch } from "react-redux"
import {
  getSettingData,
  updateSetting,
  clearMessage,
} from "../../store/settings/actions"
import { getCarParks as onGetCarParks } from "../../store/carpark/actions"
import { messageTitle } from "constants/common"
import CPFProperties from "./CPFProperties"
import PMSIntegration from "./PMSIntegration"
import StripeIntegration from "./StripeIntegration"
import EmailConfiguration from "./EmailConfiguration"
import PaymentSettings from "./PaymentSettings"
import ComplimentaryAuthority from "./ComplimentaryAuthority"
import ConsolidatedBills from "./ConsolidatedBills"
import Legal from "./Legal"
import isEmpty from "lodash/isEmpty"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

const SystemSetting = () => {
  const dispatch = useDispatch()

  const { settingData, isSettingUpdated, message, error, carParkData } =
    useSelector(state => ({
      settingData: state.Settings.settingData,
      isSettingUpdated: state.Settings.isSettingUpdated,
      message: state.Settings.message,
      error: state.Settings.error,
      carParkData: state.carPark.carParkList,
    }))
  useEffect(() => {
    dispatch(getSettingData())
    dispatch(onGetCarParks({ status: "Available" }))
  }, [dispatch, isSettingUpdated])

  /*=
   */
  const [settings, setSettings] = useState({})
  const [carParkList, setCarparks] = useState([])

  useEffect(() => {
    setSettings(settingData)
  }, [settingData])

  useEffect(() => {
    if (carParkData) {
      const list = (carParkData || []).map(el => {
        return {
          key: el._id,
          title: el.carParkTitle,
          url: "",
          entryCode: "",
          exitCode: "",
        }
      })
      setCarparks(list)
    }
  }, [carParkData])

  useMemo(() => {
    if (message) {
      toastr.success(message, messageTitle)
      dispatch(getSettingData())
      setTimeout(() => {
        dispatch(clearMessage())
      }, 300)
    }
  }, [dispatch, message])

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(error.message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])

  const onChangeSettings = (field, value) => {
    console.log('field, value', field, value);
    setSettings(prevState => {
      let newState = { ...prevState }
      if (field === "complimentaryAuthority") {
        newState[field] = value
      } else {
        newState[field] = { ...value }
      }
      onUpdateSettings(newState)
      return newState
    })
  }
  const onUpdateSettings = newState => {
    console.log(newState)
    dispatch(updateSetting(newState._id, newState))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">System Settings</h4>
                <div className="page-title-right"></div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <CPFProperties
                settings={settings["cpfProperties"] || {}}
                onChangeSettings={onChangeSettings}
                onUpdate={onUpdateSettings}
              />
              {/* <StripeIntegration
                settings={settings["stripeIntegration"] || {}}
                onChangeSettings={onChangeSettings}
                onUpdate={onUpdateSettings}
              /> */}
              {/* <EmailConfiguration
                settings={settings["emailConfiguration"] || {}}
                onChangeSettings={onChangeSettings}
                onUpdate={onUpdateSettings}
              /> */}
              <ComplimentaryAuthority
                settings={settings["complimentaryAuthority"] || {}}
                onChangeSettings={onChangeSettings}
                onUpdate={onUpdateSettings}
              />
{/*               <ConsolidatedBills
                settings={settings["billingEmailConfig"] || {}}
                onChangeSettings={onChangeSettings}
                onUpdate={onUpdateSettings}
              /> */}
            </Col>
            <Col lg={6}>
              <PMSIntegration
                settings={settings["pmsIntegration"] || {}}
                onChangeSettings={onChangeSettings}
                carParks={carParkList}
              />
              <PaymentSettings
                settings={settings["paymentSettings"] || {}}
                onChangeSettings={onChangeSettings}
                onUpdate={onUpdateSettings}
              />
              {/* <Legal
                settings={settings["legal"] || {}}
                onChangeSettings={onChangeSettings}
                onUpdate={onUpdateSettings}
              /> */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SystemSetting
